import MeetingCard from './meetingCard';
import React , {useState, useEffect, useContext} from 'react'
import axios from "axios";

import {AppContext} from '../context/AppProvider'
import  guestCredentials  from '../seeders/guestCredentials';
import EnvRoute from '../middleware/envRoute';
import * as API from '../helpers/APICalls'

const ENDPOINT = EnvRoute('prod'); 
const guest = guestCredentials

// import { fetchMeetings } from '../../../api/controllers/meetingControllers';


// let meetings = require('../seeders/seedMeetings.json');



// function getCardInfo(){
//     const PORT=3000
//     const MONGO_URI="mongodb://localhost:27017/meetings"
//  }
function handleNewMeeting(){
   // window.location.href= '/create-Meeting'
   console.log('Coming soon!')
}


function Meetings(props) {

   // const username = props.user   
   // window.localStorage.setItem('TH_user',JSON.stringify(user))
   let header //= { header:'header'}
   let scroll_section //= {scroll_selection:'scroll_selection'}
   let inner_scroll_section =  document.getElementById(`meetings-header`)
   let elem_rect
   let offset
   let body_rect 
   const localUser = JSON.parse(localStorage.getItem('TH_user'))

   
   const {
      // isLoggedIn, 
      // setIsLoggedIn,
      view,
      setView,
      room,
      setRoom,
      user,
      setUser,
      meetings,
      setMeetings,
      currentMeeting, 
      setCurrentMeeting,
      notifications,
      setNotifications,
      isLoading,
      setIsLoading } = useContext(AppContext)
      const username = user.email   
   //  document.addEventListener("DOMContentLoaded",getTag("header","meetings-header-wrap"))

   const tempId ="645408675bdddab6ae01828f"
   
   const token = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6IjY0NTQwODY3NWJkZGRhYjZhZTAxODI4ZiIsImlhdCI6MTY4MzIyODc3NSwiZXhwIjoxNjg1ODIwNzc1fQ.R-mT12-OY0WApViLJF5dbmOa8oO1qd9SbKOTjfpGi-k"
   
    const fetchMeetings = async () =>{
         console.log('[fetchMeetings]  user.token: ',localUser?.token)
     try {
      const config = {
        headers: {
         // Authorization: `Bearer ${user.token}`,//!---production
         'Content-Type': 'application/json', 
          Authorization: `Bearer ${localUser?.token}`,
        },
        body: {
           _id: localUser?._id
         }
      };
      
      // console.log("pre fetch user: ", user)
      const data  = await axios.post(`${ENDPOINT}/api/meeting/all/`, config)
      //   const data  = await axios.post(`${ENDPOINT}/api/meeting/all`, config)
      console.log("data: ",data.data)
      let resp = data.data
      try{
        await  setMeetings(data)
         localStorage.setItem("TH_meetings", JSON.stringify(data));
         // setMeetings(JSON.parse(localStorage.getItem("TH_meetings")));
         console.log("meetings: ", meetings)

        //    let  mtgs = data.data
        //   setMeetings([...mtgs]);
        }catch(er){console.log('Meetings not set.',er)}
    } catch (err) {console.log(err)}
         setMeetings(localStorage.getItem("TH_meetings"));

    // console.log("[Hub] fetchMeetings ---> Meetings: ", meetings)
    
}

   // const meetings = fetchMeetings()

   function getTag(sect_lbl,tag){
       console.log('getTag [shrugs]')
      if(sect_lbl === "header"){
         header =  document.getElementById(`${tag}`)
         console.log("header selected")
      }else if(sect_lbl === "scroll_section"){
         scroll_section =  document.getElementById(`${tag}`)
            // console.log("scrolling:",rect.top)
      } 
    
    
         
      // let sect_toup =(sect_lbl,sect)
        
      //  sect =  document.querySelector(`${tag}`)
      //  scroll_section =  document.getElementById('meeting-content-wrap')
      //  header =  document.getElementById('meetings-header-wrap')
      //  header =  document.getElementById('header')
      console.log(`getTags ${tag} for:`, sect_lbl)
      // console.log(`getTags sect_toup:`, sect_toup)
      // console.log("getTags scroll_section:",scroll_section)
       return sect_lbl
      }; 

  function initTags(){
         getTag("scroll_section","meeting-content-wrap")
         getTag("inner_scroll_section ","meeting-content")
         getTag("header","meetings-header-wrap")
         if(scroll_section){
            let scroll = false
            let orig_pos 
           
            scroll_section.addEventListener('scroll', (event) => {
               scroll = true
               console.log("scrolling:",scroll_section) 
               console.log("scrolling:",event.offsetY) 
               
               // if(scroll_section && header && inner_scroll_section){
               if(scroll){
                  header.classList='meetings-header-wrap show-header-shadow'
                  // elem_rect = scroll_section.getBoundingClientRect()
                  // orig_pos = elem_rect.top
                  // if(inner_scroll_section){
                  // scroll_section.addEventListener('scroll')
                     // body_rect = inner_scroll_section.getBoundingClientRect()

                     // offset = elem_rect.top - orig_pos
                     // if(elem_rect){
                     //    console.log("elem_rect.top: ",elem_rect)
                     // }
                     console.log("all three")
                     // console.log("offset: ",offset)
                     // console.log("header.classList: ",header.classList)
                     // if (offset)
                     
                     // else{header.classList='meetings-header-wrap'}
                  // }
               }
            })
            if (!scroll){
               header.classList = 'meetings-header-wrap'
            }else{header.classList='meetings-header-wrap show-header-shadow'}
         }
      }
   // document.addEventListener("DOMContentLoaded",initTags())
   
   // if(document.addEventListener("DOMContentLoaded",getTags(scroll_section,"meeting-content-wrap"))){ 
   //    scroll_section.addEventListener('scroll', (event) => {
   //    console.log("scrolling")
   //    // if(!header){
   //    //    getTags()
   //    //    console.log("should be toggling 🤔")
         
   //    // }else{header.classList.toggle('show-header-shadow')}
   // })
   //    }//else{getTags()}
   // if(scroll_section){ 
   //    scroll_section.addEventListener('scroll', (event) => {
   //    console.log("scrolling")
      // if(!header){
      //    getTags()
      //    console.log("should be toggling 🤔")
         
      // }else{header.classList.toggle('show-header-shadow')}
   // })
      //else{getTags()}
   function generateMeetings(){
      
      // let mtgs = JSON.parse(localStorage.getItem("TH_meetings"))
      let mtgs = JSON.parse(meetings)
      console.log('[Meetings] generateMeetings: ', mtgs)
      if(mtgs?.length >0){

         let meeting_map = mtgs?.map((meeting,index) => {
            console.log('[Meetings] generateMeetings meeting: ', meeting)
   
             return (
                <>
                {meetings && (<MeetingCard 
                       meeting={meeting} 
                       key={index} 
                       value={meeting?._id} 
                       view={view}  
                       setView={props.setView}/>)}
                </>
                       )
          })
          return meeting_map   
      }else return null
    }
    useEffect(() => {
      
   
      return () => {
        fetchMeetings()
      }
    }, [])
    
    
    return (
        <div className="meetings-container">  
           
        <div className="meetings-header-wrap" id="meetings-header-wrap" >
            <div className="meetings-header" id="meetings-header" >
                  <span className='add-new-meeting blink' onClick={handleNewMeeting}><span className='add-new-meeting-btn'>&nbsp;+&nbsp;</span> &nbsp;new meeting</span>
               <span className='blink-slowerer' id="user-tag">greetings:<span className='user-text'> {localUser.preferredName}</span></span>
                  <h1 className="view-header blink-slower">{props.view}</h1>
            </div>
         </div>
            <div id='meeting-content-wrap'>
               <div className='meeting-content' id="meeting-content">
                  {/* {generateMeetings()} */}
                  { meetings?.length >0? generateMeetings():<h3 className='center'>No meetings available</h3>}
               </div>
            </div>
        </div>
  );
}
export default Meetings; 